import { render } from "./log-injection.vue?vue&type=template&id=587f6d0e&scoped=true"
import script from "./log-injection.vue?vue&type=script&lang=js"
export * from "./log-injection.vue?vue&type=script&lang=js"

import "./log-injection.vue?vue&type=style&index=0&id=587f6d0e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587f6d0e"]])

export default __exports__